import { Element, Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: "zpr-accordion"
})

export class ZprAccordion {
    @Element() host: HTMLElement;
    @Prop() multiple:boolean = true;

    componentDidLoad(){

        if (this.multiple) return;

        // Close all other details when one is shown
        this.host.addEventListener('panelOpened', (event) => {
          [...this.host.children as any].map(panels => {
              panels.isOpen = event.target === panels
            });
        });
    }

    render() {
        return (
            <Host><slot></slot></Host>
        )
    }
}
